export default function TrainingFormats() {
  const formats = [
    { icon: 'ri-user-star-line', title: 'Корпоративный тренинг', desc: 'Интенсивное обучение Soft Skills для всей команды: 2–3 дня практики, реальные кейсы компании, отработка коммуникаций, обратной связи и командного взаимодействия.' },
    { icon: 'ri-stack-line', title: 'Серия модулей', desc: 'Поэтапное развитие на 2–4 месяца: каждый модуль — новое умение с практикой и закреплением между встречами. Оптимально для глубокой проработки.' },
    { icon: 'ri-vidicon-line', title: 'Онлайн-формат', desc: 'Дистанционное обучение с интерактивными упражнениями, виртуальными досками и breakout-комнатами. Удобно для распределённых команд.' },
    { icon: 'ri-building-2-line', title: 'Офлайн-формат', desc: 'Очное обучение в аудитории — максимальное погружение, живое взаимодействие, энергия группы и немедленная обратная связь.' },
    { icon: 'ri-compasses-2-line', title: 'Фасилитация', desc: 'Групповая работа для поиска решений, стратегирования и формирования общего видения с развитием навыков коммуникации и слушания.' },
    { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Игровые форматы для отработки Soft Skills в безопасной среде: командообразование, переговоры и принятие решений в условиях неопределённости.' },
    { icon: 'ri-user-3-line', title: 'Индивидуальный коучинг', desc: 'Персональная работа над развитием конкретных Soft Skills: эмоциональный интеллект, лидерство, управление конфликтами.' },
    { icon: 'ri-heart-pulse-line', title: 'Долгосрочное сопровождение', desc: 'Поддержка команды в течение 6–12 месяцев: регулярные сессии, аудит изменений, корректировка траектории развития.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Форматы обучения Soft Skills
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Выберите формат под задачи бизнеса. Все программы адаптируются под отрасль, должности сотрудников и цели компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {formats.map((format, i) => (
            <div key={i} className="bg-white p-6 rounded-xl hover:ring-2 hover:ring-teal-200 transition-all group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${format.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{format.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{format.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}